
import React from "react"; 
import { toast } from 'react-toastify'; 

//import DOMPurify from 'dompurify'; 
import CustomApiError from "../models/CustomApiError";
 
class Notifier {
    // Initialize toast configuration if needed
     
     
    static showSuccess(message: string|null|undefined ) { 
      if(message)
      {
        const rawHtml = `<div> 
                  <p>${this.convertToHtml(message??"")}</p>
                </div>`;
        const sanitizedHtml = rawHtml; //DOMPurify.sanitize(rawHtml);
        toast.success(<div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />,
        {
          position: 'bottom-right',
          autoClose: 5000, 
          hideProgressBar: false, 
          closeOnClick: false, 
        }); 
      }
    }
    static showSuccessMsg(message: string|null|undefined ) { 
      if(message)
      { 
        const rawHtml = `<div> 
                  <p>${this.convertToHtml(message??"")}</p>
                </div>`;
        const sanitizedHtml = rawHtml; //DOMPurify.sanitize(rawHtml);

        toast.success(<div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />, 
        {
          position: 'bottom-right',
          autoClose: 5000, 
          hideProgressBar: false, 
          closeOnClick: false, 
        }); 
      }
    }

    static showError(message: string|null|undefined) { 
      Notifier.showTitleError(undefined,message);
    }
    static showTitleError(title:string|null|undefined,message: string|null|undefined) { 
      console.log(message)
      if(message)
      { 
        const rawHtml = `<div>
                  ${title?"<h4>"+this.convertToHtml(title)+"</h4>":""}
                  <p>${this.convertToHtml(message??"")}</p>
                </div>`;
        const sanitizedHtml = rawHtml; //DOMPurify.sanitize(rawHtml);

        toast.error(
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />, 
          {
            position: 'bottom-right',
            autoClose: 5000,  
            hideProgressBar: false,  
            closeOnClick: false,
          }
        );

      }
    }
    static showCustomError(err:CustomApiError) {   
      console.log(err)
          switch(err.code)
          { 
            case 404:  
                Notifier.showTitleWarning(err.title,err.message); 
              break;  
            default:
              if(err.title)
                Notifier.showTitleError(err.title,err.message);
              else
                Notifier.showError(err.message); 
          } 
 
    }

    static showWarning(message: string|null|undefined) { 
        return this.showTitleWarning(null,message);
    }
    static showTitleWarning(title:string|null|undefined,message: string|null|undefined) { 
      if(message)
      {
        const rawHtml = `<div>
                  ${title?"<h4>"+this.convertToHtml(title)+"</h4>":""}
                  <p>${this.convertToHtml(message??"")}</p>
                </div>`;
        const sanitizedHtml = rawHtml; //DOMPurify.sanitize(rawHtml);

        toast.warning(
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />, 
          {
            position: 'bottom-right',
            autoClose: 5000,  
            hideProgressBar: false,  
            closeOnClick: false,
          }
        );
      }
    }

    static convertToHtml(str: string) { 
        if(str && typeof str === 'string') {
        var element = document.createElement('div');
        
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent!;
            element.textContent = '';
            

            return str; 
        }else return ''; 
    }
  }
  
  export default Notifier;